import { createAction, props } from '@ngrx/store';

export const getDefaultCropYear = createAction('[App] Get default crop year');

export const setDefaultCropYear = createAction(
  '[App] Set default crop year',
  props<{ cropYear: number }>(),
);

export const setAvailableCropYears = createAction(
  '[App] Set available crop years',
  props<{ availableCropYears: number[] }>(),
);

export const setCropYear = createAction('[App] Set crop year', props<{ cropYear: number }>());

export const contextChanged = createAction('[App] Context changed');
